import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Brands from '../LandingPage/component/Brands'
import NewAcademy from '../NewHomePage/components/NewAcademy'
import NewTestimonials from '../NewHomePage/components/NewTestimonials'
import { serviceContent } from '../services/utils'
import useLocale from '../../components/Hooks/useLocale'
import { urlWithLocalization } from '../../components/LocalizationUrl/UrlWithLocalization'
import language from '../../helpers/language'
import ItalianFood from '../../components/Seo-helmet/service/Italian-Food.js'
import SellerBenefits from './components/SellerBenefits'
import SellerImages from './components/SellerImages'
import NewsLetter from '../about/component/NewsLetter'

const sellerService = serviceContent.find(s => s.slug === 'italian-food-beverage-producers')

const SellerPage = () => {
  const [lang] = useState(language.getLang())
  const localeLocalization = useLocale()

  return (
    <div className="font-sf-pro">
      <ItalianFood />

      {/* Dark blue banner */}
      <div
        className="w-full md:px-16 px-6 md:pt-40 pt-32 md:pb-20 pb-14 text-center"
        style={{ backgroundColor: "#004577" }}
      >
        <h1 className="md:text-5xl text-3xl font-extrabold text-white mb-5 leading-tight">
          {lang?.Seller_page_title}
        </h1>
        <p className="text-white text-base font-normal max-w-2xl mx-auto leading-relaxed">
          {lang?.Seller_page_description}
        </p>
        <div className="flex flex-wrap gap-4 justify-center mt-8">
          <Link
            to={urlWithLocalization(localeLocalization, sellerService.joinLink)}
            className="px-8 py-3 bg-green-500 hover:bg-green-600 hover:text-white text-white font-semibold rounded-md transition-colors text-sm shadow-md"
          >
            {lang?.join_as_producers}
          </Link>
        </div>
      </div>

      {/* Trusted by logo slider */}
      <Brands />

      {/* Benefits accordion */}
      <SellerBenefits />


      {/* Two-image gallery */}
      <SellerImages />

      {/* Alysei Academy */}
      <NewAcademy />

      {/* Testimonials */}
      <NewTestimonials />

      {/* Join Alysei CTA */}
      <NewsLetter joinLink={sellerService.joinLink} />
    </div>
  )
}

export default SellerPage
